import React from 'react'

import InfoLinesBox from './InfoLinesBox';

const AnalysisSpectroscopyInfo = () => {

	let infoTitle = ""
	let infoLines = []

	return (
		<InfoLinesBox title={infoTitle} lines={infoLines} />
	)
}

export default AnalysisSpectroscopyInfo
